$shm_hitalama_process_monitor $mol_book2
	menu_title \Процессы
	close? null
	spread? \
	menu_tools /
		<= Exclude_filter $mol_pick
			trigger_content /
				<= Exclude_icon $mol_icon_filter_off
			bubble_content /
				<= Exclude_label $mol_view
					sub / \Исключить
				<= Exclude_input $mol_string
					hint \Подстрока
					value? <=> exclude_substr? \
		<= Close $mol_button_minor
			hint \Закрыть процессы
			click? <=> close?
			sub / <= Close_icon $mol_icon_close
	pages /
		<= Menu $mol_page
			Title => Menu_title
			title <= menu_title
			Tools => Menu_tools
			tools <= menu_tools
			body /
				<= Menu_filter $mol_search
					query? <=> menu_filter? \
				<= Menu_links $shm_tree
					roots <= root_process_ids /
					children* <= process_children* /
					expanded*? <=> process_expanded*? true
					Item* <= Menu_item* $mol_view
						attr *
							^
							shm_hitalama_process_monitor_current <= detail_current* false
						sub /
							<= Menu_detail* $mol_button_minor
								click? <=> detail_click*? null
								sub /
									<= Process_duration* $mol_paragraph
										title <= process_duration* \
										style *
											^
											width <= process_duration_width* \1ch
							<= Menu_widget* $mol_button_minor
								click? <=> widget_click*? null
								sub /
									<= Menu_link_title* $mol_dimmer
										needle <= menu_filter
										haystack <= spread_title*
									<= Menu_link_status* $mol_view
										style *
											^
											color <= process_status_color*
											backgroundColor <= process_status_tint*
										sub / <= process_status*
		<= spread_current
	spread_current null
	spread_title* \
	detail_current* false
	process_status_color* \
	process_status_tint* \
	Page* $shm_hitalama_process_monitor_detail
		key <= key*
		close? <=> detail_close*? null
	key* <= key_default \
	detail_close*? null
	exclude_substr? \
